import {
  MutationHookOptions,
  useMutation,
} from '@apollo/client';

import { UPDATE_USER_ENTITY_PERMISSION } from '@frontend/app/queries';
import {
  UpdateUserEntityPermission,
  UpdateUserEntityPermissionVariables,
} from '@frontend/app/queries/types/UpdateUserEntityPermission';

type IOptions = MutationHookOptions<
  UpdateUserEntityPermission,
  UpdateUserEntityPermissionVariables
>;

export function useUpdateUserEntityPermission(options: IOptions = {}) {
  return useMutation<UpdateUserEntityPermission, UpdateUserEntityPermissionVariables>(UPDATE_USER_ENTITY_PERMISSION, options);
}
